import { LINKS, SUPPORT_PREFILL_ENTRIES } from "@/config/links";

export type PrefillValues = { userId?: string; device?: string; os?: string; appVersion?: string };

/**
 * 1.19 고객센터 구글 폼 프리필: `${supportForm}?usp=pp_url&entry.<id>=값` (AC0-230 entry 2개).
 * 회원번호 1칸 + "기기 · OS · 앱 버전" 1칸(없는 항목은 빼고 " · "로 잇는다). 주문번호는 사용자가 폼에서 직접 입력. 값이 없는 칸은 생략.
 */
export function buildPrefillUrl(values: PrefillValues): string {
  const url = new URL(LINKS.supportForm);
  url.searchParams.set("usp", "pp_url");
  const put = (id: string, value: string | undefined) => {
    if (value) url.searchParams.set(`entry.${id}`, value);
  };
  put(SUPPORT_PREFILL_ENTRIES.userId, values.userId);
  put(SUPPORT_PREFILL_ENTRIES.deviceInfo, [values.device, values.os, values.appVersion].filter(Boolean).join(" · "));
  return url.toString();
}
